import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const faqData = [
  {
    question: 'Wie schnell können Sie starten?',
    answer: 'Bei dringenden Anfragen sind wir oft in 24-48 Stunden bereit. Wenn es geplant ist, ist eine Woche Vorlauf gut, damit wir alles perfekt vorbereiten können.'
  },
  {
    question: 'Arbeiten Sie auch im Ausland?',
    answer: 'Ja, wir arbeiten in der Schweiz und international. Wir haben Partner auf der ganzen Welt und können Sie überall hin begleiten.'
  },
  {
    question: 'Wie unauffällig sind Sie?',
    answer: 'Diskretion ist uns sehr wichtig. Unsere Leute können sich im Hintergrund halten, sodass Sie Ihren Alltag ganz normal leben können.'
  },
  {
    question: 'Was kostet Personenschutz?',
    answer: 'Die Kosten hängen von verschiedenen Faktoren ab: Umfang des Schutzes, Dauer, Einsatzort und spezielle Anforderungen. Wir erstellen gerne ein individuelles Angebot nach einem unverbindlichen Erstgespräch via WhatsApp.'
  },
  {
    question: 'Wie halten wir Kontakt?',
    answer: 'Sie haben einen festen Ansprechpartner, den Sie immer erreichen können. Wir nutzen sichere Wege für die Kommunikation.'
  },
  {
    question: 'Können Sie auch kurzfristige Event-Sicherheit übernehmen?',
    answer: 'Ja, wir sind auf flexible Einsätze spezialisiert. Für grössere Events empfehlen wir jedoch eine Vorlaufzeit von mindestens 2 Wochen, um ein umfassendes Sicherheitskonzept zu erstellen.'
  },
];

export const FAQ = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="faq"
      className="section-padding bg-[#0B0F19]"
      data-testid="faq-section"
    >
      <div className="container-custom">
        {/* Header */}
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 md:mb-16"
        >
          <span className="text-[#D4AF37] uppercase tracking-[0.3em] text-xs font-medium">
            Häufige Fragen
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-[#F1F5F9] mt-4 mb-6 font-['DM_Sans']">
            Fragen & Antworten
          </h2>
          <p className="text-[#94A3B8] max-w-2xl mx-auto">
            Hier finden Sie Antworten auf die häufigsten Fragen. Für weitere
            Informationen kontaktieren Sie uns gerne direkt via WhatsApp.
          </p>
        </motion.div>

        {/* Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-3xl mx-auto"
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqData.map((item, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-[#111625] border border-[#1E293B] rounded-sm px-6 data-[state=open]:border-[#D4AF37]/30 transition-colors"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="text-left text-[#F1F5F9] hover:text-[#D4AF37] py-5 text-base md:text-lg font-medium font-['DM_Sans'] [&[data-state=open]]:text-[#D4AF37]">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-[#94A3B8] pb-5 leading-relaxed">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
